import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { name, reducer } from './slice';
import saga from './saga';

export default function useZones() {
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
}
